import type { FieldValues, Path, UseFormSetError } from 'react-hook-form';
import { ApiClientError } from './client';

/**
 * Walks `ApiClientError.details` (the 422 field-errors map) into
 * react-hook-form's `setError`. Each key may be a dotted path like
 * `items.0.title`; we let RHF resolve it.
 */
export function applyServerErrors<T extends FieldValues>(
  setError: UseFormSetError<T>,
  error: unknown,
): boolean {
  if (!(error instanceof ApiClientError)) return false;
  if (error.status !== 422 || !error.details) return false;
  const details = error.details as Record<string, unknown>;
  let applied = false;
  for (const [key, value] of Object.entries(details)) {
    const message = typeof value === 'string' ? value : JSON.stringify(value);
    setError(key as Path<T>, { type: 'server', message });
    applied = true;
  }
  return applied;
}

export function errorMessage(error: unknown, fallback = 'Something went wrong'): string {
  if (error instanceof ApiClientError) return error.message || fallback;
  if (error instanceof Error) return error.message || fallback;
  return fallback;
}
